import { useContext } from 'react';
import KitchenPlayerContext from '../contexts/KitchenPlayerContext';

export default function useKitchenPlayerContext() {
  return useContext(KitchenPlayerContext);
}
